/** Unauthenticated dashboard preview, rendered from mock data. */
export const GUEST_ROUTE = "/home-guest";

const GUEST_FLAG = "guestMode";

// Guest mode has to outlive the guest route the way auth outlives any single
// page — otherwise the nav vanishes the moment a guest opens Remote.
// sessionStorage (not localStorage) so it dies with the tab, like a session.
export const enterGuestMode = (): void => {
  try {
    window.sessionStorage.setItem(GUEST_FLAG, "true");
  } catch {
    /* ignore — private mode / storage disabled */
  }
};

export const isGuestSession = (): boolean => {
  try {
    return window.sessionStorage.getItem(GUEST_FLAG) === "true";
  } catch {
    return false;
  }
};

export const exitGuestMode = (): void => {
  try {
    window.sessionStorage.removeItem(GUEST_FLAG);
  } catch {
    /* ignore — private mode / storage disabled */
  }
};
